import { RefObject, useEffect, useState } from 'react';

export const useTooltipEllipsis = (initialText: string, ref: RefObject<HTMLElement | null>) => {
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            const element = ref.current;
            if (element) {
                // Anche in altezza: un nome tagliato su più righe (`line-clamp`) trabocca in giù, non di lato.
                setIsOverflowing(element.offsetWidth < element.scrollWidth || element.scrollHeight > element.clientHeight + 1);
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);

        return () => {
            window.removeEventListener('resize', checkOverflow);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialText]);

    return isOverflowing;
};
